// extracted by mini-css-extract-plugin
module.exports = {"carouselBase":"styles_carouselBase__UTiUA","carousel":"styles_carousel__EtWTk","pagination":"styles_pagination__4hio_"};